import React, { useState, useEffect } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { Hero, MapsPreview } from './components';
import AlbanianMap from 'components/organisms/AlbanianMap';
import LatestNewsPreview from './components/LatestNewsPreview';
import clsx from 'clsx';
import SectionWithArrows from 'components/organisms/SectionWithArrows/SectionWithArrows';
import { WebService } from 'services/WebService';
import { useWindowSize } from 'hook';
import { NewsService } from 'services';
import Slider from 'react-slick';

const useStyles = makeStyles((theme) => ({
  fontWeight900: {
    fontWeight: 900,
  },
  albanianMap: {
    height: 750,
    [theme.breakpoints.down('xs')]: {
      width: 340,
    },
  },
  mapContainer: {
    [theme.breakpoints.down('md')]: {
      margin: '0 auto',
    },
  },
  mapInfoContainer: {
    [theme.breakpoints.down('md')]: {
      margin: '0 auto',
      left: 'unset',
    },
  },
  slideshow: {
    height: 150,
    backgroundColor: '#1F2835',
  },
}));

const Home = () => {
  const defaultCitySelected = 'Tiranë';
  const classes = useStyles();
  const windowSize = useWindowSize();
  const webService = new WebService();
  const newsService = new NewsService();

  const delay = 2000;
  // const transitionTime = 1500;
  const defaultNewsSlideShowContainerWidth = 500;
  const elementsToShow =
    windowSize.width >= defaultNewsSlideShowContainerWidth ? windowSize.width / defaultNewsSlideShowContainerWidth : 1;

  const [municipalities, setMunicipalities] = useState([]);
  const [mapInfo, setMapInfo] = useState({});
  const [news, setNews] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await webService.municipalities();
      setMunicipalities(data);
    })();

    (async () => {
      const { data } = await newsService.news();

      setNews(data);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCitySelected = async (cityName) => {
    const city = municipalities.find((x) => x.name === cityName);
    const municipality = await webService.municipalitiesById(city.id);

    setMapInfo(municipality);
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: delay,
    slidesToShow: elementsToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: delay,
    draggable: false,
    pauseOnHover:false,
    pauseOnFocus: false,
  };

  return (
    <div>
      <Hero />

      <Slider {...settings} className={clsx(classes.slideshow)}>
        {news.map((x, index) => (
          <LatestNewsPreview key={+index} news={x} />
        ))}
      </Slider>

      {municipalities.length && (
        <SectionWithArrows>
          <Grid container>
            <Grid item md={6} xs={12} className={clsx(classes.mapContainer)}>
              <AlbanianMap
                className={clsx(classes.albanianMap)}
                selectOnClick={true}
                onClick={(e) => {
                  const { name } = e;
                  if (e.selected) onCitySelected(name);
                  else setMapInfo({});
                }}
                onFirstLoad={(chart) => {
                  onCitySelected(defaultCitySelected);
                  const tiraneChart = chart.series[0].data.find((x) => x.name === defaultCitySelected);
                  tiraneChart.select();
                }}
              />
            </Grid>
            <Grid item md={6} xs={12} className={clsx(classes.mapInfoContainer)}>
              <MapsPreview data={mapInfo} />
            </Grid>
          </Grid>
        </SectionWithArrows>
      )}
    </div>
  );
};

export default Home;
